import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { Game, Tournament, TournamentApi } from '@mtgame/core';
import { getGameRoute, getTeamPageRoute, getTournamentRoute } from '@config/routes';


@Component({
  selector: 'mtg-league-galo-tournament-card',
  templateUrl: './league-galo-tournament-card.component.html',
  styleUrls: ['./league-galo-tournament-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeagueGaloTournamentCardComponent implements OnChanges {
  @Input()
  tournament: Tournament;
  game: Game;

  constructor(
    private tournamentApi: TournamentApi,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.tournament && this.tournament) {
      this.getGame();
    }
  }

  async getGame() {
    const games = await this.tournamentApi.getGames(this.tournament.id, 1, 1);
    this.game = games.data[0];
    this.cdr.markForCheck();
  }

  get tournamentBg(): string {
    return this.tournament.previewImage.path;
  }

  getTournamentRoute(): string[] {
    return getTournamentRoute(this.tournament.alias);
  }

  getGameRoute(gameId: number): string[] {
    return getGameRoute(gameId);
  }

  getTeamRoute(teamId: number): string[] {
    return getTeamPageRoute(teamId);
  }
}
